/* External */
import { memo } from 'react';

/* Ott-common */
import Skeleton from '@dtvgo/skeleton';

function MiniScheduleCardSkeleton() {
  return (
    <Skeleton className="dtv-html5-c-mini-schedule-card__skeleton" dark />
  );
}

export default memo(MiniScheduleCardSkeleton);
